import { useState } from 'react';
import { API_BASE } from '../config';
import SeoHead from './SeoHead';
import { Breadcrumbs } from './ComponentLibrary';
import { pageMeta } from '../seoUtils';

function ContactPage() {
  const [formData, setFormData] = useState({ name: '', email: '', subject: '', message: '' });
  const [submitted, setSubmitted] = useState(false);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    setError('');
    try {
      const res = await fetch(`${API_BASE}/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.error || 'Failed to send message');
      }
      setSubmitted(true);
      setFormData({ name: '', email: '', subject: '', message: '' });
    } catch (err) {
      setError(err.message);
    } finally {
      setSending(false);
    }
  };

  const seo = pageMeta({
    title: 'Contact Us',
    description:
      'Get in touch with Naija Nest Properties. We are here to help with your property needs in Nigeria.',
    path: '/contact',
  });

  return (
    <div className="static-page contact-page">
      <SeoHead title={seo.fullTitle} description={seo.desc} url={seo.url} image={seo.img} />
      <Breadcrumbs
        items={[
          { label: 'Home', href: '/' },
          { label: 'Contact Us', current: true },
        ]}
      />
      <section className="section">
        <header className="contact-page__intro">
          <h1>Contact Us</h1>
          <p className="static-page__lead">Have a question, feedback, or need help?</p>
        </header>
        <div className="static-page__contact-grid">
          <div className="static-page__contact-info">
            <div className="static-page__contact-card">
              <h3>Email</h3>
              <p>
                <a href="mailto:hello@naijanestproperties.com">hello@naijanestproperties.com</a>
              </p>
            </div>
            <div className="static-page__contact-card">
              <h3>WhatsApp</h3>
              <p>
                <a href="https://wa.me/2349043933993" target="_blank" rel="noreferrer">
                  +234 904 393 3993
                </a>
              </p>
            </div>
            <div className="static-page__contact-card">
              <h3>Instagram</h3>
              <p>
                <a
                  href="https://instagram.com/naijanest_prime_hub"
                  target="_blank"
                  rel="noreferrer"
                >
                  @naijanest_prime_hub
                </a>
              </p>
            </div>
            <div className="static-page__contact-card">
              <h3>Location</h3>
              <p>Lagos, Nigeria</p>
            </div>
            <div className="static-page__contact-card">
              <h3>Response Time</h3>
              <p>Within 24 hours</p>
            </div>
          </div>
          <div className="static-page__contact-form-wrapper">
            {submitted ? (
              <div className="static-page__success">
                <h3>Message Sent!</h3>
                <p>We'll get back to you soon.</p>
                <button type="button" className="btn-link" onClick={() => setSubmitted(false)}>
                  Send another
                </button>
              </div>
            ) : (
              <form className="static-page__contact-form" onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="c-name">Name</label>
                  <input
                    id="c-name"
                    name="name"
                    type="text"
                    className="ui-input"
                    placeholder="Your name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="c-email">Email</label>
                  <input
                    id="c-email"
                    name="email"
                    type="email"
                    className="ui-input"
                    placeholder="you@example.com"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="c-subject">Subject</label>
                  <select
                    id="c-subject"
                    name="subject"
                    className="ui-select"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select a topic</option>
                    <option value="general">General Inquiry</option>
                    <option value="listing">Listing Issue</option>
                    <option value="report">Report Fraud</option>
                    <option value="feedback">Feedback</option>
                    <option value="partnership">Partnership</option>
                  </select>
                </div>
                <div className="form-group">
                  <label htmlFor="c-msg">Message</label>
                  <textarea
                    id="c-msg"
                    name="message"
                    className="ui-input"
                    placeholder="Tell us more..."
                    rows="5"
                    value={formData.message}
                    onChange={handleChange}
                    required
                  />
                </div>
                {error && (
                  <p className="form-error" style={{ color: '#dc2626', marginBottom: '12px' }}>
                    {error}
                  </p>
                )}
                <button type="submit" className="ui-button primary" disabled={sending}>
                  {sending ? 'Sending...' : 'Send Message'}
                </button>
              </form>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}
export default ContactPage;
